import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IDialogProps } from '../../lib/dialog/Dialog';
import Button from '../../lib/button/Button';
import OwnUserProfileContent from './OwnUserProfileContent';
import { getCurrentUserOrLogoutRedirect } from '../../auth';
import { getUser, resolveUserDisplayLabel } from '../../services/user';
import PublicUserProfileContent from './PublicUserProfileContent';
import { Logger } from '@elyx-code/common-ts-utils';

interface IUserProfileDialogProps extends IDialogProps {}

const UserProfileDialog: React.FC<
	Omit<IUserProfileDialogProps, 'children'>
> = ({ onClose }) => {
	const [user, setUser] = useState<any | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isOwnProfile, setIsOwnProfile] = useState<boolean | null>(null);
	const { id: projectId, userId } = useParams<{ id: string; userId: string }>();
	const navigate = useNavigate();

	useEffect(() => {
		const init = async () => {
			// const userProfileId = tab;
			Logger.log('---- User profile id from URL ----', userId);

			setIsLoading(true);

			const [currentUser, userProfile] = await Promise.all([
				getCurrentUserOrLogoutRedirect(),
				getUser({ id: userId }),
			]);

			setUser(userProfile);

			if (currentUser?.id === userProfile?.id) {
				setIsOwnProfile(true);
			} else {
				setIsOwnProfile(false);
			}

			setIsLoading(false);
		};

		init();
	}, []);

	const loaded = user !== null && isOwnProfile !== null;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
				gap: '4px',
				padding: '40px',
			}}
		>
			<div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
				<button className='dialog_back_button' onClick={onClose}>
					<i className='fa-solid fa-arrow-left' />
				</button>
				<h1 style={{ margin: '0px', fontWeight: 500, fontSize: '28px' }}>
					{!loaded
						? 'Account'
						: isOwnProfile
							? 'Your account'
							: resolveUserDisplayLabel(
									user,
									isLoading ? '' : 'Account deleted',
								)}
				</h1>
			</div>

			<div
				style={{
					flex: 1,
					margin: '0 42px',
					marginTop: '16px',
					overflow: 'scroll',
				}}
			>
				{!loaded ? (
					'Loading...'
				) : isOwnProfile ? (
					<OwnUserProfileContent user={user} />
				) : (
					<PublicUserProfileContent user={user} />
				)}
			</div>
			<div
				style={{
					alignSelf: 'flex-start',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-end',
					width: '100%',
					gap: '16px',
				}}
			>
				<Button onClick={() => navigate('editor/' + projectId)} variant='text'>
					Back
				</Button>
			</div>
		</div>
	);
};

export default UserProfileDialog;
